export const FETCH_PACKING_ENTRY_DATA_REQUEST = 'FETCH_PACKING_ENTRY_DATA_REQUEST';
export const FETCH_PACKING_ENTRY_DATA_SUCCESS = 'FETCH_PACKING_ENTRY_DATA_SUCCESS';
export const FETCH_PACKING_ENTRY_DATA_FAILURE = 'FETCH_PACKING_ENTRY_DATA_FAILURE';

export const FETCH_SINGLE_PACKING_ENTRY_DATA_REQUEST = 'FETCH_SINGLE_PACKING_ENTRY_DATA_REQUEST';
export const FETCH_SINGLE_PACKING_ENTRY_DATA_SUCCESS = 'FETCH_SINGLE_PACKING_ENTRY_DATA_SUCCESS';
export const FETCH_SINGLE_PACKING_ENTRY_DATA_FAILURE = 'FETCH_SINGLE_PACKING_ENTRY_DATA_FAILURE';

export const CREATE_USER_FORM_PACKING_ENTRY = 'CREATE_USER_FORM_PACKING_ENTRY';

export const SET_UNIT_NAME_PACKING_ENTRY = 'SET_UNIT_NAME_PACKING_ENTRY';

export const FETCH_PACKING_ENTRY_TABLE_DATA_REQUEST = 'FETCH_PACKING_ENTRY_TABLE_DATA_REQUEST';
export const FETCH_PACKING_ENTRY_TABLE_DATA_SUCCESS = 'FETCH_PACKING_ENTRY_TABLE_DATA_SUCCESS';
export const FFETCH_PACKING_ENTRY_TABLE_DATA_FAILURE = 'FETCH_PACKING_ENTRY_TABLE_DATA_FAILURE';

export const PACKING_ENTRY_USERFORM_RESET = 'PACKING_ENTRY_USERFORM_RESET';

export const CREATE_PACKING_ENTRY_REQUEST = 'CREATE_PACKING_ENTRY_REQUEST';
export const CREATE_PACKING_ENTRY_SUCCESS = 'CREATE_PACKING_ENTRY_SUCCESS';
export const CREATE_PACKING_ENTRY_FAILURE = 'CREATE_PACKING_ENTRY_FAILURE';

export const CREATE_PACKING_ENTRY_DETAIL_REQUEST = 'CREATE_PACKING_ENTRY_DETAIL_REQUEST';
export const CREATE_PACKING_ENTRY_DETAIL_SUCCESS = 'CREATE_PACKING_ENTRY_DETAIL_SUCCESS';
export const CREATE_PACKING_ENTRY_DETAIL_FAILURE = 'CREATE_PACKING_ENTRY_DETAIL_FAILURE';

export const CREATE_USERFORM_PACKING_TABLE_LIST_DATA = 'CREATE_USERFORM_PACKING_TABLE_LIST_DATA';

export const FETCH_PACKING_ENTRY_DETAIL_DATA_REQUEST = 'FETCH_PACKING_ENTRY_DETAIL_DATA_REQUEST';
export const FETCH_PACKING_ENTRY_DETAIL_DATA_SUCCESS = 'FETCH_PACKING_ENTRY_DETAIL_DATA_SUCCESS';
export const FETCH_PACKING_ENTRY_DETAIL_DATA_FAILURE = 'FETCH_PACKING_ENTRY_DETAIL_DATA_FAILURE';

export const NAVIGATE_PACKING_ENTRY_DETAILS = 'NAVIGATE_PACKING_ENTRY_DETAILS';

export const NAVIGATE_PACKING_ENTRY_HEADER = 'NAVIGATE_PACKING_ENTRY_HEADER';

export const DELETE_PACKING_ENTRY_REQUEST = 'DELETE_PACKING_ENTRY_REQUEST';
export const DELETE_PACKING_ENTRY_SUCCESS = 'DELETE_PACKING_ENTRY_SUCCESS';
export const DELETE_PACKING_ENTRY_FAILURE = 'DELETE_PACKING_ENTRY_FAILURE';

export const DELETE_PACKING_ENTRY_DETAIL_REQUEST = 'DELETE_PACKING_ENTRY_DETAIL_REQUEST';
export const DELETE_PACKING_ENTRY_DETAIL_SUCCESS = 'DELETE_PACKING_ENTRY_DETAIL_SUCCESS';
export const DELETE_PACKING_ENTRY_DETAIL_FAILURE = 'DELETE_PACKING_ENTRY_DETAIL_FAILURE';

export const FETCH_WAREHOUSE_STYLE_NUMBER_DATA_ID_REQUEST = 'FETCH_WAREHOUSE_STYLE_NUMBER_DATA_ID_REQUEST';
export const FETCH_WAREHOUSE_STYLE_NUMBER_DATA_ID_SUCCESS = 'FETCH_WAREHOUSE_STYLE_NUMBER_DATA_ID_SUCCESS';
export const FETCH_WAREHOUSE_STYLE_NUMBER_DATA_ID_FAILURE = 'FETCH_WAREHOUSE_STYLE_NUMBER_DATA_ID_FAILURE';

export const FETCH_WAREHOUSE_INWARD_APPROVAL_ACCEPT_OR_REJECT_REQUEST = 'FETCH_WAREHOUSE_INWARD_APPROVAL_ACCEPT_OR_REJECT_REQUEST';
export const FETCH_WAREHOUSE_INWARD_APPROVAL_ACCEPT_OR_REJECT_SUCCESS = 'FETCH_WAREHOUSE_INWARD_APPROVAL_ACCEPT_OR_REJECT_SUCCESS';
export const FETCH_WAREHOUSE_INWARD_APPROVAL_ACCEPT_OR_REJECT_FAILURE = 'FETCH_WAREHOUSE_INWARD_APPROVAL_ACCEPT_OR_REJECT_FAILURE';

export const FETCH_WAREHOUSE_INWARD_RATIO_CONVERSION_REQUEST = 'FETCH_WAREHOUSE_INWARD_RATIO_CONVERSION_REQUEST';
export const FETCH_WAREHOUSE_INWARD_RATIO_CONVERSION_SUCCESS = 'FETCH_WAREHOUSE_INWARD_RATIO_CONVERSION_SUCCESS';
export const FETCH_WAREHOUSE_INWARD_RATIO_CONVERSION_FAILURE = 'FETCH_WAREHOUSE_INWARD_RATIO_CONVERSION_FAILURE';